export const changeHolePageConfirm = 'changeHole:confirm';
export const eventChangeSocket = 'changeSocket:confirm';
export const eventChangeStrokeWidth = 'changeStrokeWidth:confirm';
export const editImagePageConfirm = 'editImage:confirm';
export const changeBackgroundPageConfirm = 'change:background';
export const whiteInkPageConfirm = 'whiteInk:confirm';
export const retouchType_normal = 'normal';
export const retouchType_keyhole = 'keyhole';
export const retouchType_yakeli = 'yakeli';
export const retouchType_lipai = 'lipai';
export const subType_shape = 'SHAPE';
export const subType_head = 'HEAD';
export const subType_body = 'BODY';
export const subType_origin = 'ORIGIN';
export const subType_shapeBody = 'SHAPE_BODY';
export const subType_shapeHead = 'SHAPE_HEAD';
export const tool_changeHole = 'changeHole';
export const tool_outline = 'outline';
export const tool_manualRetouch = 'manualRetouch';
export const tool_changeImage = 'changeImage';
export const tool_editImage = 'editImage';
export const tool_rotate = 'rotate';
export const tool_shape = 'shape';
export const useDefaultRetouch = 'useDefaultRetouch'; //  默认抠图

export const tool_original = 'original'; // 原图
export const tool_fullBodyRetouch = 'fullBodyRetouch'; // 抠全身
export const tool_headRetouch = 'headRetouch'; // 只抠图
export const tool_retouch = 'retouch'; // 抠图
export const tool_noRetouch = 'noRetouch'; // 不抠图
export const tool_noRetouch1 = 'noRetouch1'; // 不抠图
export const tool_showRetouch = 'showRetouch'; // 显示抠图
export const tool_moveSocket = 'moveSocket'; // 移插口
export const tool_changeBg = 'changeBg'; // 换背景
export const tool_whiteInk = 'whiteInk'; // 白墨
export const tool_mainBody = 'mainBody'; // 主体
export const tool_clear = 'clear'; // 清空
export const tool_upload = 'upload'; // 上传
export const tool_default = 'default'; // 默认
export const tool_uploadOutline = 'uploadOutline'; // 上传刀线
export const tool_template = 'template'; // 模板
export const tool_imageZindex = 'imageZindex'; // 图片置底
export const tool_setting = 'setting'; // 设置
export const tool_text = 'text'; // 文字
export const tool_zoomin = 'zoomin'; // 放大
export const tool_zoomout = 'zoomout'; // 缩小

export const action_moveSocket = 'moveSocket'; // 移插口
export const action_changehole = 'changeHole';
export const action_changestrokewidth = 'changeStrokeWidth';

// 边框常量（单位：毫米）
export const BORDER_WIDTH = {
  COLOR_PAPER: 1, // 色纸边框
  BAJI: 4, // 吧唧边框
  COLOR_PAPER_SHADOW: 1.3 // 实际测试: 不会使得预览图留白的保险的值
};

// 位置常量
export const POSITION = {
  TOP_CENTER: 'TOP_CENTER',
  BOTTOM_CENTER: 'BOTTOM_CENTER',
  MAX_TOP: 'TOP',
  MAX_BOTTOM: 'BOTTOM'
};

// Layer 类型常量
export const layer_userImage = 'userImage'; // 用户原图类型
export const layer_template = 'template'; // SKU 模板类型
export const layer_skuMaterial = 'material'; // SKU 素材类型
export const layer_background = 'background'; // 背景图类型
export const layer_transparentGrid = 'transparentGrid'; // 透明网格底图（仅用于编辑UI展示，不参与导出合成）

export const backgroundDefaultOpacity = 0.45; // 背景默认透明度
export const backgroundDefaultOpacity_layer = 1; // 模板方案的背景透明度

export const backgroundMaxZIndex = -100; // type=background的图层 最大 zIndex
export const maxLayerZIndex = 100; // 图层中最大的层级
export const maxLayerCount = 20; // 最大图层个数
// 后台模板zIndex=-1时, 设置的初始zIndex,  为让 maxLayerCount 个layer 可以调整 zIndex 小于 type=skuTemplate 的 zIndex
export const minSkyTemplateZIndex = backgroundMaxZIndex + maxLayerCount;

export const transparentGridZIndex = -1000; // 透明网格底图的zIndex

export const emptyWhiteInk = '-1'; //  表示白墨清空

export const whiteInkRgba = 'rgba(255,255,255,1)'; // 白墨RGBA颜色值

export const SNAP_ANGLE_CORRECTION_RANGE = 3; // 修正角度范围（度）
export const SNAP_POSITION_CORRECTION_RANGE = 3; // 位置修正范围（像素）

export const subType_BADGE_LAMINATED = 'BADGE_LAMINATED_TEMPLATE'; // 模板覆膜吧唧
export const subType_SHAN = 'BADGE_SHAN_TEMPLATE'; //模板双闪吧唧

export const subType_COLOR_ARR = ['COLOR_JN', 'COLOR_ALPHA', 'COLOR_SHAN']; // 色纸\透明色纸 \双闪

// 吧唧
export const subType_BAJI_ARR = [
  subType_BADGE_LAMINATED,
  subType_SHAN,
  'BADGE_LAMINATED',
  'BADGE_SHAN'
];

export function isTemplateBaji(subType) {
  return subType_BAJI_ARR.indexOf(subType) > -1;
}

// 色纸
export function isTemplateColorPaper(subType) {
  return subType_COLOR_ARR.indexOf(subType) > -1;
}

// 判断模板sku中是否需要跳转 previewColorPaperNew 页面进行后续处理
export function isTemplateSkuWithColorPaper(subType) {
  return [...subType_COLOR_ARR, ...subType_BAJI_ARR].indexOf(subType) > -1;
}

export const whiteInkFilterAlpha = 0.7 * 255; // 白墨过滤透明度

export const skuTemplate = 'skuTemplate';
